import Page from 'src/seo/Page'
import Organizations from 'src/organization/Organizations'
import { GetStaticProps } from "next"
import { AlgoliaIndexes } from "projectlink-common"
import initServerIndex from "src/search/algoliaServer"
import topicsService from "src/server/services/topics"

function CompaniesPage({ initialHits, initialTopics }) {
  return (
    <Page
      name={`Heavy industry companies`}
      description={`${initialTopics.map(t => t.name).join(', ')} companies`}
      path={`/companies`}
    >
      <Organizations
        initialHits={initialHits}
        initialTopics={initialTopics}
      />
    </Page>
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const index = initServerIndex(AlgoliaIndexes.organizations)
  const r = await index.search('', { hitsPerPage: 8 })
  const topics = await topicsService.getAll()

  return {
    props: {
      initialHits: r.hits,
      initialTopics: topics,
    },
    revalidate: 3,
  }
}

export default CompaniesPage
